export default ['urn:xmpp:getgo:gotomeeting-invitation:0'];
